export default __webpack_public_path__ + "static/media/shopping_cart.26e90545.svg";